var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.122 10.062C20.122 4.504 15.617 0 10.06 0 4.504 0 0 4.504 0 10.062c0 5.02 3.68 9.182 8.489 9.937v-7.03H5.935v-2.908h2.554V7.845c0-2.522 1.502-3.915 3.8-3.915 1.1 0 2.252.196 2.252.196v2.476h-1.268c-1.25 0-1.64.776-1.64 1.571v1.889h2.791l-.446 2.908h-2.344V20c4.81-.755 8.488-4.917 8.488-9.938z",
    fill: "#fff"
  })));
}

export default SvgFacebook;